import fwUtil from 'framework-util'

const sysDictService = new fwUtil.ApiService.ApiService('sysDict');
export { sysDictService }



// WEBPACK FOOTER //
// ./src/api/generator/generator/sysDict.js